export default "__VITE_ASSET__f7a0e565__"